import { UsersAllTab } from "./UsersAllTab";

export default UsersAllTab;
